// extracted by mini-css-extract-plugin
module.exports = {"card":"TextCard_card__2G5hz","location":"TextCard_location__2zLPG","date":"TextCard_date__Dijb7","text":"TextCard_text__2amK9","icon":"TextCard_icon__2GKPm"};